import './FocusRing.css'

export const FocusRing = () => <div className="focus-ring" />
